import { ContentItem } from '@kerfjs/ui/content-item';
import { List } from '@kerfjs/ui/list';
import { ListInsetControl } from '@kerfjs/ui/list-inset-control';
import { LoadingSpinner } from '@kerfjs/ui/loading-spinner';
import { Row } from '@kerfjs/ui/row';
import { Text } from '@kerfjs/ui/text';
import type { SafeHtml } from 'kerfjs';

import { decisionSummary } from '../../../data/state.js';
import { DecidedBadges } from './decided-badges.js';
import { DecisionSummaryTable } from './decision-summary-table.js';

export function DecisionSummaryPane(): SafeHtml {
  const summary = decisionSummary.value;
  if (summary === null)
    return (
      <ContentItem appearance="surface" frame="framed" className="decision-summary-pane">
        <LoadingSpinner label="Loading summary" />
      </ContentItem>
    );
  return (
    <List className="decision-summary-pane" gap="l">
      <Row vAlign="middle" gap="xs" wrap controlInsets="rl">
        <DecidedBadges
          decidedCount={summary.decidedCount}
          total={summary.totalLines}
          allDecided={summary.totalLines > 0 && summary.decidedCount === summary.totalLines}
        />
        {/* Export moved to the single Share control in the sub-header (HS2-41ZSXD). */}
      </Row>
      <ListInsetControl sides="rl">
        <Text tone="quiet" size="compact" flush>
          {summary.demandTitle} — for the business office.
        </Text>
      </ListInsetControl>
      <DecisionSummaryTable summary={summary} />
    </List>
  );
}
